

<ng-container *ngIf="searchModel['AgencyID']==null">
  <search-section ></search-section>
  <search-location-page   > </search-location-page>

</ng-container>

<ng-container *ngIf="searchModel['AgencyID']!=null">
  <search-section ></search-section>
  <search-vehicle-page  ></search-vehicle-page> <!--[searchModel]="searchModel"-->
</ng-container>
